import { useState } from "react";
import { ModalMenuItem, ModalSubmenu } from "../../../components";
interface ProviderServicesAddTopbarProps {
  onChangeTab: (tab: string) => void;
}

export const ProviderServicesAddTopbar = ( { onChangeTab } : Readonly<ProviderServicesAddTopbarProps>) => {

  const [activeTab, setActiveTab] = useState<string>('Add Service');

  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
    onChangeTab(tab);
  };

  const items: ModalMenuItem[] = [
    {
      label: 'Add Service',
      url: '',
      clickHandler: () => handleTabChange('Add Service'),
      ifActive: activeTab === 'Add Service' ? 'active' : '',
    },
    {
      label: 'Add Service Type',
      url: '',
      clickHandler: () => handleTabChange('Add Service Type'),
      ifActive: activeTab === 'Add Service Type' ? 'active' : '',
    },
  ]

  return <ModalSubmenu className="p-0" items={items} />;
};

export default ProviderServicesAddTopbar;
